import {defineStore} from "pinia";
import axios from "axios";
import {BACKEND_BASEURL} from "@/config/config";
import DateUtil from "@/lib/es-bill-shared-js/util/DateUtil";


/**
 * Contract store
 * Uniquely identifies contract by _id from MongoDB
 */
export const useExportStore = defineStore('export', {
  state: () => ({}),

  actions: {

    async getEnergyDumpForCommunity(ecn, ecid, dateStart, dateEnd) {
      try {
        const urlParts = [
          "exports",
          ecn,
          ecid,
          "exportEnergySumsOverTime",
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));
        return response.data;

      } catch (error) {
        console.error('Failed to fetch energy dump:', error);
        throw error;
      }
    }, // getUncleanMps


  }
});
